<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
             Department of Agri Product Sale and Marketing/ ຕະຫຼາດ
            
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid==6 || roleid==7">
        <b-tab-item label="ລາການຕະຫຼາດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາການຕະຫຼາດ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="30%">
                        ບ້ານ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activemarkets"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>
                     
                      <td class="has-text-centered">
                          <b-field group>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  openSaveForm(data.ID, data.MARKETNAME,data.PROVINCEID, data.PROVINCENAME)"
                                >ເພີ່ມຈຸດສົ່ງສິນຄ້າ
                              </b-button>
                            </b-field>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-info"
                                size="is-small"
                                @click="
                                  openShippingFeeForm(data.ID, data.MARKETNAME,data.PROVINCEID, data.PROVINCENAME)"
                                >ລາຍລະອຽດຈຸດສົ່ງ
                              </b-button>
                            </b-field>
                          </b-field>
                          
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        
        <b-tab-item label="ລາຍລະອຽດຈຸດສົ່ງ">
          <div class="columns scrollme">
            <div class="column">
                <h3 class="title">{{selectedMarketname}}</h3>
            </div>
          </div>
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍລະອຽດຈຸດສົ່ງ">
                
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ/ ເມືອງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເຂດ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ລາຍລະອຽດບ້ານ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຄ່າສົ່ງທັງໝົດ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຄ່າສົ່ງ Rirder
                      </th>
                      <th class="has-text-centered " width="15%">
                        ສະຖານະ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activeshippingfee"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.PROVINCENAME }} <br> {{data.DISTRICTNAME}}
                      </td>
                      <td>
                        {{ data.DESTINATIONZONE }}
                      </td>
                      <td>
                        {{ data.DETAIL }}
                      </td>
                      <td class="has-text-right ">
                        {{ data.FEE | formatNumberLocal}}
                      </td>
                      <td class="has-text-right ">
                        {{ data.RIDER_FEE | formatNumberLocal}}
                      </td>
                     
                      <td class="has-text-centered">
                          <b-field group>
                            <b-field v-if="data.ISACTIVE ==1"> 
                               ໃຊ້ງານ
                            </b-field>
                            <b-field v-if="data.ISACTIVE ==0"> 
                              ຖືກປິດ
                            </b-field>
                 
                          </b-field>
                        
                      </td>
                      <td class="has-text-centered">
                          <b-field group>
                            <b-field v-if="data.ISACTIVE ==1"> 
                              <b-button class="btn-group-margin"
                                type="is-info"
                                size="is-small"
                                @click="
                                  changeSataus(data.MARKETID,data.ID, 0)"
                                >ປິດໃຊ້ງານ
                              </b-button>
                            </b-field>
                            <b-field v-if="data.ISACTIVE ==0"> 
                              <b-button class="btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="
                                  changeSataus(data.MARKETID,data.ID, 1)"
                                >ເປີດໃຊ້ງານ
                              </b-button>
                            </b-field>

                            <b-field > 
                              <b-button class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  updateForm(data)"
                                >ແກ້ໄຂ
                              </b-button>
                            </b-field>
                 
                          </b-field>
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ຟອມເພີ່ມ/ ແກ້ໄຂຈຸດສົ່ງ">
          <div class="columns" >
            <div class="column">
              <h3 class="title">{{selectedMarketname}}</h3>
            </div>
          </div>
          <div class="columns" >
            <div class="column">
              <h3 class="title">{{selectedProvincename}}</h3>
            </div>
          </div>
          
         <div class="columns" >
            <div class="column">
              <h3 class="title-sub">ເພິ່ມ/ ແກ້ໄຂຈຸດສົ່ງ</h3>
            </div>
          </div>
          
          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                <div class="column">
                  <b-field label="ເມືອງ">
                    <Multiselect
                    placeholder="ເລືອກ"
                    v-model.trim="selectedDistrict"
                    label="NAME"
                    track-by="ID"
                    :options="districtList"
                  >
                  </Multiselect>
                  </b-field>
                </div>

                <div class="column">
                  <b-field label="ເຂດສົ່ງສິນຄ້າ">
                    <b-input v-model.trim="zone"> </b-input>
                  </b-field>
                </div>
                
                
                <div class="column">
                  <b-field label="ລາຍລະອຽດ">
                    <b-input v-model.trim="detail" maxlength="500" type="textarea"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ຄ່າສົ່ງທັງໝົດ">
                    <b-input v-model.trim="fee"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="ຄ່າສົ່ງ Rider">
                    <b-input v-model.trim="rider_fee"> </b-input>
                  </b-field>
                </div>
              </div>
              
             
              <b-field label="" style="float: right">
                <b-field v-if="saveAction">
                  <button class="button is-info" @click="saveForm">
                    ບັນທຶກ
                  </button>
                </b-field>
                <b-field v-if="updateAction">
                  <div class="columns">
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-primary"
                          @click="updateData"
                        >
                          ແກ້ໄຂ
                        </button>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-info"
                          @click="openSaveForm()"
                        >
                          ເພີ່ມຈຸດສົ່ງ
                        </button>
                      </b-field>
                    </div>
                  </div>
                </b-field>
              </b-field>
            </div>
          </div>

        </b-tab-item>
        
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
    roleid: null,
    userName: null,

    saveAction: true,
    updateAction: false,
    adddataform: true,
    updatedataform: false,
    zone: null,
    detail: null,
    fee: 0,
    rider_fee: 0,

    activemarkets: [],
    marketid: null,

    activeTab: 0,    
    branchUsername: null,
    userProvince: null,

    activeshippingfee: [],
    inactiveshippingfee: [],
    selectedMarketid: null,
    selectedMarketname: null,
    selectedProvinceid: null, 
    selectedProvincename: null,
    selectedDistrict: null,
    districtList: [],
    zoneid: null,
  };
  },
  methods: {
    openSaveForm(ID=null, NAME = null, PROVINCEID = null, PROVINCENAME = null){
      this.activeTab = 2;
      this.saveAction = true;
      this.updateAction = false;
      this.selectedMarketid = ID ? ID : this.selectedMarketid;
      this.selectedMarketname = NAME ? NAME : this.selectedMarketname;
      this.selectedProvinceid = PROVINCEID ? PROVINCEID : this.selectedProvinceid;
      this.selectedProvincename = PROVINCENAME ? PROVINCENAME : this.selectedProvincename;
      this.zone = null;
      this.detail = null;
      this.fee = null;
      this.rider_fee = null;
      this.getDistrict();
    },
   saveForm() {
      if (this.zone === null || this.detail === null || this.fee === null || this.fee === 0  || this.rider_fee === 0  || this.selectedDistrict === null) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
          marketid: this.selectedMarketid,
          provinceid: this.selectedProvinceid,
          districtid: this.selectedDistrict.ID,
          zone: this.zone,
          detail: this.detail,
          fee: this.fee,
          rider_fee: this.rider_fee,
          village: this.village,
          username: this.username
        };
        // console.log("params : " + JSON.stringify(params))
        RestAPI.saveShippingdata(params)
          .then(res => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate zone") {
              this.$swal(
                "ເຂດຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }


            this.$swal(" ສຳເລັດ!", "", "success");
            
            this.activeTab = 1;
            this.saveAction = true;
            this.updateAction = false;
            this.zone = null;
            this.detail = null;
            this.fee = null;
            this.rider_fee = null;
            this.zoneid = null;
            this.openShippingFeeForm(this.selectedMarketid);
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    updateForm(data){
      this.activeTab = 2;
      this.saveAction = false;
      this.updateAction = true;
      this.zone = data.DESTINATIONZONE;
      this.detail =data.DETAIL;
      this.fee = data.FEE;
      this.rider_fee = data.RIDER_FEE;
      this.zoneid = data.ID;
      this.selectedProvinceid = data.PROVINCEID;
      this.selectedProvincename = data.PROVINCENAME;
      this.selectedDistrict ={"ID": data.DISTRICTID,"NAME": data.DISTRICTNAME};
      this.getDistrict();
      console.log("this.selectedProvinceid: " + this.selectedProvinceid)
      
    },
    updateData() {
     if (this.zone === null || this.detail === null || this.fee === null || this.fee === 0  || this.rider_fee === null || this.rider_fee === 0  || this.selectedDistrict === null ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      } else {
        var params = {
        zoneid: this.zoneid,
        provinceid: this.selectedProvinceid,
        districtid: this.selectedDistrict.ID,
        zone: this.zone,
        detail: this.detail,
        fee: this.fee,
        rider_fee : this.rider_fee,
        village: this.village,
        username: this.username
      };

      // console.log("pa: " + JSON.stringify(params))
     
      RestAPI.updateShippingdata(params)
        .then(res => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate zone") {
              this.$swal(
                "ເຂດຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }


            this.$swal(" ສຳເລັດ!", "", "success");
            
            this.activeTab = 1;
            this.saveAction = true;
            this.updateAction = false;
            this.zone = null;
            this.detail = null;
            this.fee = null;
            this.rider_fee = null;
            this.zoneid = null;
            this.openShippingFeeForm(this.selectedMarketid, this.selectedMarketname);
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
      
    },
    getMarkets() {
      RestAPI.getMarkets(this.branchUsername)
        .then(res => {
          console.log("list:"+ JSON.stringify(res.data))
          this.activemarkets = res.data.activemarkets;
          this.inactivemarkets = res.data.inactivemarkets;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    openShippingFeeForm(ID, NAME, PROVINCEID = null, PROVINCENAME = null) {
      this.activeTab = 1;
      this.selectedMarketid =ID;
      this.selectedMarketname = NAME;
      this.selectedProvinceid = PROVINCEID;
      this.selectedProvincename = PROVINCENAME;
      // console.log("this.selectedMarketid: " + this.selectedMarketid)
      RestAPI.getMarketShippingFee(ID)
      .then(res => {
        this.activeshippingfee = res.data;
        
      })
      .catch(error => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
      
    },

    changeSataus(marketid, id,status){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            table: "m_shipping_fee",
            id: id,
            status: status,
            username: this.username
          };
          console.log("params + ", JSON.stringify(params))
          RestAPI.changeSataus(params)
            .then(() => {
            
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.openShippingFeeForm(this.selectedMarketid, this.selectedMarketname);

            })
            .catch(error => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },

    getDistrict(){
      RestAPI.getDistrict(this.selectedProvinceid)
        .then(res => {
          // console.log("country selected...")
          this.districtList = res.data;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
   
    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvince = this.user.PROVINCEID;
    this.branchUsername = this.user.ROLEID == 6 ? 'ALL' : this.user.USERNAME,
    this.getMarkets();
    
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
